// data shared in components: Pagination, PaginationWithInput

import store from '../../store'
import * as searchSetters from './store/searchStore-setters'
import * as searchGetters from './store/searchStore-getters'
import * as search from './search'

// check if current page is first
const isFirstPage = () => {
  return searchGetters.currentPage() == 1
}

// check if current page is the last
const isLastPage = () => {
  return searchGetters.currentPage() == searchGetters.totalPagesNum()
}

const setActivePage = (n) => {
  if (searchGetters.currentPage() != n) {
    searchSetters.setCurrentPage(n);
    searchSetters.setPageStart(n);
    search.loadResults()
  }
}

const setPreviousPage = () => {
  // if current page is not first set previous page
  if(!isFirstPage()) {
    setActivePage(searchGetters.currentPage() - 1);
  }
}

const setNextPage = () => {
  // if current page is not last set next page
  if(!isLastPage()) {
    setActivePage(searchGetters.currentPage() + 1);
  }
}

const isDisplayed = (n) => {
  // check if page number should be displayed (first, last, one before last, current page, one before and one after current page)
  return n == 1 || n > searchGetters.totalPagesNum() - 2 || (n > searchGetters.currentPage() - 2) && (n < searchGetters.currentPage() + 2)
}

// check if ellipsis between numbers should be displayed
const isDisplayedEllipsis = (n) => {
  return n == searchGetters.currentPage() - 2 || n == searchGetters.currentPage() + 2
}

// update current page number to the one set in input (number should be greater then 0 and less/equal to the total number of pages)
const updateCurrentPage = (event) => {
  let newCurrentPage = parseInt(event.target.value);

  if(newCurrentPage > 0 && newCurrentPage <= searchGetters.totalPagesNum()) {
    setActivePage(newCurrentPage);
  }
}

export {
  isFirstPage,
  isLastPage,
  setNextPage,
  setPreviousPage,
  setActivePage,
  isDisplayed,
  isDisplayedEllipsis,
  updateCurrentPage
}



// WEBPACK FOOTER //
// ./src/scripts/modules/pagination.js